import { render } from "./BlankPage.vue?vue&type=template&id=0efe40ce&scoped=true&ts=true"
import script from "./BlankPage.vue?vue&type=script&lang=ts"
export * from "./BlankPage.vue?vue&type=script&lang=ts"

import "./BlankPage.vue?vue&type=style&index=0&id=0efe40ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0efe40ce"]])

export default __exports__